import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './app';
import configureStore from './configureStore';
import ErrorBoundary from './common/error-boundary';
import 'bootstrap/dist/css/bootstrap.min.css';

const store = configureStore();

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  //  <React.StrictMode>
  <ErrorBoundary level="root">
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorBoundary>
  //  </React.StrictMode>,
);
